
const ConnectionMonitor = {
    onlineCallback: () => {},
    offlineCallback: () => {},

    init(onlineCallback, offlineCallback) {
        this.onlineCallback = onlineCallback
        this.offlineCallback = offlineCallback

        // if browser detects online confirm it by checking the
        // connection to the server and performing sync
        window.addEventListener('online', this.onlineCallback);

        // if browser detects offline
        window.addEventListener('offline', this.offlineCallback);
    },

    destroy() {
        window.removeEventListener('online', this.onlineCallback);
        window.removeEventListener('offline', this.offlineCallback);
    }
};

export default ConnectionMonitor;

export { ConnectionMonitor };
